import { Container, Grid, Box, Skeleton } from '@mui/material';
import React, { FC } from 'react';

const KnowBeforeRideSectionSkeleton: FC<any> = () => {
  return (
    <Box py={8}>
     <Container maxWidth="xl">
       <Skeleton variant="text" width="300px"  height={100} />
         <Grid container spacing={4}>
             {[...Array(7)].map((_, item) => (
                <Grid item lg={3} md={6} sm={12} key={item}>
                  <Skeleton variant="text" height={60} width="80%" />
                  <Skeleton variant="rectangular" width="100%"  height={100} />
                </Grid>
              ))}
        </Grid>
     </Container>
     </Box>
  );
};

export { KnowBeforeRideSectionSkeleton };